import React, { useState } from 'react';
import { Props } from './DrawerDesktop.config';
import classes from './DrawerDesktop.module.scss';

const DrawerDesktop: React.FC<Props> = ({ menuOptions, closeDrawer }) => {
  const [activeItem, setActiveItem] = useState<number | null>(null);

  const handleItemClick = (index: number, href: string, hasSubitems: boolean) => {
    if (hasSubitems) {
      setActiveItem(activeItem === index ? null : index); // Toggle submenu
    } else if (href) {
      window.location.href = href; // Redirect if href is provided
    }
  };

  return (
    <>
        <div className={classes.drawer}>
        <div onClick={closeDrawer} className={classes.closeButton}>
            <img
            width={15}
            height={15}
            src={require('../../../assets/icons/cross.svg').default}
            alt="Close"
            />
        </div>
        <ul className={classes.menu}>
            {menuOptions.map((option, index) => (
            <li key={index} className={classes.menuItem}>
                <div
                className={`${classes.menuItemTitle} ${(activeItem === index ? classes.active : '')}`}
                onClick={() =>
                    handleItemClick(index, option.href, !!option.subitems)
                }
                >
                    <div className={classes.title}>
                        {option.title}
                    </div>
                    {option.subitems && option.subitems.length > 0 && (<span>{activeItem === index ? '-' : '+'}</span>)}
                </div>
                {activeItem === index && option.subitems && (
                <ul className={classes.submenu}>
                    {option.subitems.map((subItem, subIndex) => (
                    <li
                        key={subIndex}
                        className={classes.submenuItem}
                        onClick={() => {
                        if (subItem.href) {
                            window.location.href = subItem.href;
                        }
                        }}
                    >
                        {subItem.title}
                    </li>
                    ))}
                </ul>
                )}
            </li>
            ))}
        </ul>
        </div>
    <div className={classes.backdrop}></div>
    </>
  );
};

export default DrawerDesktop;
